import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/guessbtc/Earn_Shells.png")